import {createAction, props} from "@ngrx/store";
import {Serializers} from "../../interfaces/serializer";
import {Channel} from "../../interfaces/channel";
import {ActionCreator, TypedAction} from '@ngrx/store/src/models';

export const loadChannels = createAction('[CHANNELS] LOAD');
export const loadPublicChannels: ActionCreator<string, (props: { uuid: string, token: string }) => TypedAction<string> & { uuid: string, token: string }> = createAction('[CHANNELS] PUBLIC_CHANNELS', props<{ uuid: string, token: string }>());
export const loadChannelSuccess = createAction('[CHANNELS] LOAD_SUCCESS', props<{ channels: Serializers<Channel> }>());
